<template>
  <div class="page-yinji-map">
    <div class="wrap">
      <div class="left-list">
        <div class="com-list-content">
          <div class="button">
            <el-row>
              <el-button class="el-primary-border" round @click="handleAdd">
                <svg-icon icon-class="add" />&nbsp;添加
              </el-button>
            </el-row>
          </div>
  
          <div class="table">
            <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
              <el-table-column label="序号" width="50">
                <template slot-scope="scope">{{ scope.$index+1 }}</template>
              </el-table-column>
              <el-table-column prop="name" label="名称" min-width="30px0%" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column prop="name" label="坐标" min-width="20%" show-overflow-tooltip></el-table-column> -->
  
              <!-- 操作 -->
              <el-table-column  fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <a class="m-btn mr-10" @click="handleClick(scope.row, 'edit')">编辑</a>
                  <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
                </template>
              </el-table-column>
            </el-table>
  
            <!-- <div class="pagination-container paging">
              <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div> -->
          </div>
        </div>
      </div>
      
      <div class="map-box">
        <el-form class="map_form" ref="form" :model="addForm" :rules="rules">
          <el-form-item label="名称 :" prop="name">
            <el-input v-model="addForm.name" :disabled="operation == 'detail'" placeholder="名称" />
          </el-form-item>

          <el-form-item label="文字 :" prop="content">
            <el-input type="textarea" v-model="addForm.content" :disabled="operation==='detail'"
              :placeholder="operation  == 'detail'? '' : '请输入'"></el-input>
          </el-form-item>
        </el-form>

        <div ref="mapContainer" id="map"></div>

        <img ref="myMap" :src="mapPic" alt="" @load="handleImageLoad" style="display: none;">
      </div>
    </div>

    <div class="pagination-container paging">
      <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>


    <!-- <el-dialog :title="operation==='add'?'新增':'编辑'" @close="onCancel" :visible.sync="dialogVisible" :width="'500px'">
      <el-form ref="form" :model="addForm" :rules="rules">
        <el-form-item class="mb-30" prop="name">
          <el-input v-model="addForm.name" :disabled="operation == 'detail'" placeholder="名称" />
        </el-form-item>

        <el-form-item label="文字 :" prop="content">
          <el-input type="textarea" v-model="addForm.content" :disabled="operation==='detail'"
            :placeholder="operation  == 'detail'? '' : '请输入'"></el-input>
        </el-form-item>

        <el-form-item class="mb-30" prop="dept">
          <el-select v-model="addForm.dept" :disabled="operation == 'detail'" placeholder="请选择所属部门">
            <el-option v-for="item in departmentArr" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer tr mt-30" v-if="operation != 'detail'">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>
  
<script>
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'
// import { RFC_2822 } from "moment";
// leaflet.pm换为leaflet-geoman-free  https://gitee.com/lianggit/leaflet.pm#getting-started
// import "@geoman-io/leaflet-geoman-free";
// import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

// Vue.L = Vue.prototype.$L = L
/* leaflet icon */
// delete L.Icon.Default.prototype._getIconUrl
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// })
export default {
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      listLoading: false,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],

      collectId: '',
      mapPic: '',
      // mapPic: 'http://download.dev.tj720.com/tmp/leaflet/tiles/{z}/{x}/{y}.png',

      map: "",
      layerList: [],
      areaArr: [],
      drawRadius: '',
      // isDrawing: false

      dialogVisible: false,
      operation: '',
      addForm: {
        id: '',
        name: '',
        content: ''
      },
      rules: {
        name: [{ required: true, message: '名称为空', trigger: 'blur' }],
      }
    };
  },
  methods: {
    show(collectId) {
      this.collectId = collectId
      this.addForm = {
        id: '',
        name: '',
        content: ''
      }
      if(this.map) {
        this.map.remove()
        this.map = null
        this.mapPic = ''

        console.log('map', this.map)
      }

      this.getData1()
    },
    handleAdd() {
      this.addForm = {
        id: '',
        name: '',
        content: ''
      }

      this.map.pm.enableDraw("Rectangle", {});
    },
    getData1() {
      this.listLoading = true
      this.tableData = []
      this.$http.get('/qinggong/qgCollectMark/list', {
        // ...this.form,
        ...this.listQuery,
        collectId: this.collectId
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
          this.mapPic = res.others

          // this.initMap2()
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.getData1()
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData1()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData1()
    },
    handleClick(item) {
      console.log(item)
      this.clearDrawings()
      let arr = []
      item.points.forEach(item => {
        arr.push({
          lng: item.longitude,
          lat: item.latitude
        })
      })
      this.areaArr = arr
      this.addForm.id = item.id
      this.addForm.name = item.name
      this.addForm.content = item.content
      console.log(3321, this.addForm)
      console.log(88888, arr)
      let area = L.polygon(this.areaArr, { color: "#fff", fillColor: '#fff', fillOpacity: 0.1 }).addTo(this.map)

      // 获取多边形的边界
      let bound = area.getBounds()

      // 调整地图视图，使多边形完全显示在地图上
      this.map.fitBounds(bound)

      // 可选：调整缩放级别，使多边形更居中
      // this.map.setZoom(this.map.getZoom() + 1)

      // // 检查选区是否在可见区域内
      // let viewBounds = this.map.getBounds()
      // if (!viewBounds.intersects(this.areaArr)) {
      //     // 如果选区不在可见区域内，定位到选区
      //     this.map.fitBounds(this.areaArr)
      // }

      this.layerList.push(area)
      this.addEvent()


      return
      // 清除所有已绘制的矩形
      clearDrawings();

      // 绘制选中的选区
      const bounds = L.latLngBounds(
          [region.bounds._southWest.lat, region.bounds._southWest.lng],
          [region.bounds._northEast.lat, region.bounds._northEast.lng]
      );
      const rectangle = L.rectangle(bounds, {
          color: '#ffffff',
          weight: 2,
          fillOpacity: 0.1
      }).addTo(map);
      drawnRectangles.push(rectangle);

      // 检查选区是否在可见区域内
      const visibleBounds = map.getBounds();
      if (!visibleBounds.intersects(bounds)) {
          // 如果选区不在可见区域内，定位到选区
          map.fitBounds(bounds);
      }
    },
    clearDrawings() {
      this.layerList.forEach(rect => this.map.removeLayer(rect))
      this.layerList = []
      this.areaArr = []
    },
    handleDelete(item) {
      this.$common.confirm(
        {
          content: '该数据将被删除，请谨慎操作'
        }, () => {
          this.$http
            .get('/qinggong/qgCollectMark/delete', {
              id: item.id
            }).then(res => {
              if (res.success) {
                this.$message.success('删除成功')
                this.getData1()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // onCancel() {
    //   this.dialogVisible = false
    //   this.addForm = {}
    //   this.$refs["form"].clearValidate()
    // },
    onSubmit() {
      console.log('areaArr', this.areaArr)
      let pointArr = []
      this.areaArr.forEach(item => {
        pointArr.push({
          latitude: item.lat,
          longitude: item.lng
        })
      })
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "/qinggong/qgCollectMark/save"
          if (this.addForm.id) {
            url = "/qinggong/qgCollectMark/update"
          }
          this.$http.post(url, {
            ...this.addForm,
            id: this.addForm.id,  // 更新
            collectId: this.collectId,
            points: pointArr
          }).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '修改成功' : '新增成功',
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {
                    id: '',
                    name: '',
                    content: ''
                  }
                  self.restList()

                  self.clearDrawings()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },
    handleImageLoad() {
      this.realWidth = this.$refs.myMap.naturalWidth;
      this.realHeight = this.$refs.myMap.naturalHeight;
      // console.log(`图片真实宽度: ${this.realWidth}, 图片真实高度: ${this.realHeight}`);

      this.initMap2()
    },
    // 图片层方式
    initMap2() {
      // 图片的像素大小
      const imageWidth = this.realWidth;
      const imageHeight = this.realHeight;
      // const imageWidth = 16206;
      // const imageHeight = 10078;
      // 瓦片大小
      const tileSize = 256;

      // 计算最大级别
      const maxZoom = Math.ceil(Math.log2(Math.max(imageWidth, imageHeight) / tileSize));

      // 初始化地图
      this.map = L.map('map', {
        // maxZoom: maxZoom, // 设置最大缩放级别
        minZoom: -2,       // 设置最小缩放级别
        crs: L.CRS.Simple, // 使用简单坐标系（非地理坐标系）
        attributionControl: false // 移除右下角leaflet标识
      });

      // 设置图片的边界（左下角和右上角坐标）
      const imageBounds = [
        [0, 0], // 左下角
        [imageHeight, imageWidth] // 右上角
      ];
      L.imageOverlay(this.mapPic, imageBounds, {
        className: 'map-pic'
      }).addTo(this.map);

      // 设置地图的最大范围，使其不会超出图片边界
      this.map.setMaxBounds([
        [0, 0],
        [imageHeight, imageWidth]
      ]);

      // 设置地图视图的中心点和缩放级别
      const initialCenter = [imageHeight / 2, imageWidth / 2];
      this.map.setView(initialCenter, 0);

      this.map.pm.setLang('zh')
      this.map.pm.addControls({
        position: "topleft",
        drawPolygon: false, // 添加绘制多边形
        drawMarker: false, //添加按钮以绘制标记
        drawCircleMarker: false, //添加按钮以绘制圆形标记
        drawPolyline: false, //添加按钮绘制线条
        drawRectangle:	true,	//添加按钮绘制矩形
        drawCircle: false, //  添加按钮绘制圆圈
        editMode: false, //  添加按钮编辑多边形
        dragMode: true, //   添加按钮拖动多边形
        cutPolygon: false, // 添加一个按钮以删除图层里面的部分内容
        // removalMode: true  // 清除图层
      })

      this.$nextTick(() => {
        this.getlatLngs()
      })
    },

    // 瓦片方式 todo后台接口未返回
    initMap3() {
      // 图片的像素大小
      const imageWidth = this.realWidth;
      const imageHeight = this.realHeight;
      // const imageWidth = 16206;
      // const imageHeight = 10078;
      // 瓦片大小
      const tileSize = 256;

      // 计算最大级别
      const maxZoom = Math.ceil(Math.log2(Math.max(imageWidth, imageHeight) / tileSize));

      // 初始化地图
      this.map = L.map('map', {
        maxZoom: maxZoom, // 设置最大缩放级别
        minZoom: 2,       // 设置最小缩放级别
        crs: L.CRS.Simple, // 使用简单坐标系（非地理坐标系）
        attributionControl: false // 移除右下角leaflet标识
      });

      // 设置地图的初始视图
      const initialCenter = [imageHeight / 2, imageWidth / 2]; // 图片中心点
      const initialZoom = 0; // 初始缩放级别
      this.map.setView(initialCenter, initialZoom);

      添加自定义瓦片图层
      L.tileLayer(this.mapPic, {
        tileSize: tileSize,   // 瓦片大小
        noWrap: true,         // 防止瓦片重复
        attribution: 'Custom Tiles', // 自定义属性
      }).addTo(this.map);

      // 设置地图的最大边界
      const southWest = this.map.unproject([0, imageHeight], maxZoom); // 左下角坐标
      const northEast = this.map.unproject([imageWidth, 0], maxZoom);  // 右上角坐标
      const bounds = L.latLngBounds(southWest, northEast);
      this.map.setMaxBounds(bounds); // 限制地图拖动范围

      this.map.pm.setLang('zh')
      this.map.pm.addControls({
        position: "topleft",
        drawPolygon: false, // 添加绘制多边形
        drawMarker: false, //添加按钮以绘制标记
        drawCircleMarker: false, //添加按钮以绘制圆形标记
        drawPolyline: false, //添加按钮绘制线条
        drawRectangle:	true,	//添加按钮绘制矩形
        drawCircle: false, //  添加按钮绘制圆圈
        editMode: false, //  添加按钮编辑多边形
        dragMode: true, //   添加按钮拖动多边形
        cutPolygon: false, // 添加一个按钮以删除图层里面的部分内容
        // removalMode: true  // 清除图层
      })

      this.$nextTick(() => {
        this.getlatLngs()
      })
    },
    initMap() {
      // var map = L.map('map', {
      //     zoomSnap: 0,
      //     edgeBufferTiles: 1,
      //     loadingControl: true,
      //     keepBuffer: 2,
      //     updateInterval: 1,
      //     fadeAnimation: true,
      //     zoomAnimation: true,
      //     inertia: true,
      //     inertiaDeceleration: 1000,
      //     crs: L.CRS.Simple
      // });

      // var path = "https://ip.e-dunhuang.com/resources/10.0001/0001/0001/0061/0001/0001/01/9/index_files/";

      // var dzLayer = L.tileLayer.deepzoom(map, path, {
      //   width: 49286,
      //   height: 20338,
      //   imageFormat: 'webp',
      //   tileSize: 1024,
      //   edgeBufferTiles: 1,
      //   updateWhenIdle: false,
      //   keepBuffer: 10,
      //   fadeAnimation: true,
      //   detectRetina: true,
      //   updateInterval: 1,
      //   opacity: 999999,
      //   reuseTiles: true,
      //   unloadInvisibleTiles: false,
      //   attribution: '&copy; 数字敦煌',
      // });
      // map.setMaxZoom(dzLayer.options.maxZoom * 1.0);
      // map.setMinZoom(dzLayer.options.maxZoom * 0.68);

      // dzLayer.addTo(map);



      this.map = L.map('map').setView([40.712216, -74.22655], 14);

      // this.map = L.map('map').setView([0, -74.22655], 13);

      // L.tileLayer('https://ip.e-dunhuang.com/resources/10.0001/0001/0001/0061/0001/0001/01/9/index_files/{z}/{x}_{y}.webp', {
      L.tileLayer('', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      let imageUrl = 'https://www.lnmuseum.com.cn/img/banner-collect.b8a2e3c4.jpg',
      imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
      L.imageOverlay(imageUrl, imageBounds, {
        className: 'map-pic'
      }).addTo(this.map);

      // L.marker([51.5, -0.09]).addTo(this.map)
      //   .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
      //   .openPopup();

      // // 设置绘制后的线条颜色等--不生效
      // // this.map.pm.setPathOptions({
      // //   color: "yellow",
      // //   fillColor: "green",
      // //   fillOpacity: 0.4
      // // });
      // // this.map.pm.enableDraw('Rectangle', {
      // //   pathOptions: {
      // //     color: 'pink',
      // //     fillColor: 'skyblue',
      // //     fillOpacity: 0.4
      // //   }
      // // });
      // this.map.pm.setLang('zh')
      // this.map.pm.addControls({
      //   position: "topleft",
      //   // drawPolygon: false, // 添加绘制多边形
      //   // drawMarker: false, //添加按钮以绘制标记
      //   // drawCircleMarker: false, //添加按钮以绘制圆形标记
      //   // drawPolyline: false, //添加按钮绘制线条
      //   // drawRectangle:	true,	//添加按钮绘制矩形
      //   // drawCircle: false, //  添加按钮绘制圆圈
      //   // editMode: false, //  添加按钮编辑多边形
      //   // dragMode: true, //   添加按钮拖动多边形
      //   // cutPolygon: false, // 添加一个按钮以删除图层里面的部分内容
      //   // removalMode: true  // 清除图层
      // })
      
      this.getlatLngs()
    },
    addEvent() {
      if(this.layerList && this.layerList[0]) {
        console.log(111111111)
        // this.layerList[0].on('pm:drag', e => {
        //   console.log('end', e)
        // })
        // this.layerList[0].off('pm:dragend', this.dragHandler)
        this.layerList[0].off('pm:drag');
        this.layerList[0].on('pm:dragend', e => {
          console.log(this.layerList[0].getBounds())
          let bounds = this.layerList[0].getBounds()
          let southWest = bounds.getSouthWest() // 西南
          let southEast = bounds.getSouthEast() // 东南
          let northWest = bounds.getNorthWest() // 西北
          let northEast = bounds.getNorthEast() // 东北 

          console.log(345, southWest)
          this.areaArr = [
            southEast,
            southEast,
            northWest,
            northEast,
          ]
          console.log(this.areaArr)
        })
        // this.layerList[0].on('pm:dragend', this.dragHandler)
      }
    },
    getlatLngs() {
      // 设置全局路径样式
      // this.map.on('pm:loaded', function() {
      //   this.map.pm.setPathOptions({
      //     color: 'orange',
      //     fillColor: 'yellow',
      //     fillOpacity: 0.4
      //   })
      // });
      //pm:drawstart 开始第一个点的时候调用
      //pm:drawend  禁止绘制时调用
      //pm:create  创建完成时调用
      this.map.on("pm:drawstart", e => {
        this.clearDrawings()
        console.log(e, "first");

        // if(!this.isDrawing) {
        //   this.map.pm.enableDraw('Rectangle', {
        //     pathOptions: {
        //       color: 'pink',
        //       fillColor: 'skyblue',
        //       fillOpacity: 0.4
        //     }
        //   })
        //   this.isDrawing = true
        // }
      });
      this.map.on("pm:drawend", e => {
        console.log(e, "禁止绘制");
      });
      this.map.on("pm:create", e => {
        console.log(e, "绘制完成时调用");
        // console.log(e.layer._latlngs, "绘制坐标")
        // this.areaArr.push(e.layer._latlngs[0])
        this.layerList.push(e.layer)
        this.areaArr = e.layer._latlngs[0]

        this.addEvent()

        // this.operation = 'add'
        // this.dialogVisible = true
      });
      
      this.map.on('pm:globaldragmodetoggled', (e) => {
        console.log(222, e);
      });

      this.map.on('pm:edit', (e) => {
        if (e.editType === 'drag') {
          // 获取被拖拽的图层
          const layer = e.layer;
          console.log('拖拽图层完成', layer);
          // 可以在这里添加拖拽完成后的处理逻辑
        }
      });

      // this.map.on('pm:globalremovalmodetoggled', function(e) {
      //   console.log('清除图层开始', e);
      // });

      this.map.on('pm:remove', e => {
        console.log('清除图层完成', e)
        this.clearDrawings()
      })
    },
    draw() {
      this.map.pm.enableDraw("Rectangle", { 
        snappable: true,
        pathOptions: {
          color: 'pink',
          fillColor: '#fff',
          fillOpacity: 0.1
        }
      });
      //   this.map.pm.enableDraw("Marker", { snappable: false });
      //   this.map.pm.enableDraw("CircleMarker", { snappable: false });
    },
    disDraw() {
      this.map.pm.disableDraw("Rectangle");
      //    this.map.pm.disableDraw('Marker');
      //    this.map.pm.disableDraw('CircleMarker');
    },
    save() {
      console.log(this.areaArr)

      if(!this.areaArr || !this.areaArr.length) {
        this.$message({
          message: '请绘制印章',
          type: 'warning'
        })
        return
      }

      this.onSubmit()

      // this.operation = 'add'
      // this.dialogVisible = true

      // this.drawObj = L.polygon(this.areaArr, { color: "#fff", fillColor: '#fff', fillOpacity: 0.1 }).addTo(this.map);
      // this.drawObj.bindTooltip('this is 个多边形');  //鼠标移上去的提示

      // color：线段颜色
      // weight：线段宽度
      // opacity：线段透明度
      // dashArray：虚线间隔
      // fill：是否填充内部(true/false)
      // fillColor:内部填充颜色，如不设置，默认为color颜色
      // fillOpacity：内部填充透明度
      // 画个圈
    //   this.drawRadius = L.circle([40.0224690112063, 116.51339229202272], {
    //     radius: 200
    //   }).addTo(this.map);
    },
  },
  // mounted() {
  //   this.initMap2()
  // },
};
</script>

<style lang="scss" scoped>
.page-yinji-map {
  .wrap {
    display: flex;

    .left-list {
      width: 400px;
      .com-list-content {
        margin: 0;
        padding-top: 0;
      }
      .item {
        display: flex;
        cursor: pointer;
  
        .btn-edit {
          margin-left: 30px;
        }
        .btn-dele {
          margin-left: 20px;
        }
      }
    }

    .map-box {
      flex: 1;

      .map_form {
        margin-top: 10px;
      }
    }
  }

}

#map {
  // margin: 0 auto;
  // width: 80%;
  flex: 1;
  height: 600px;
  z-index: 1;
}
// .btn {
//   position: absolute;
//   z-index: 9;
//   top: 10px;
//   left: 200px;
//   color: #fff;
//   font-size: 20px;
//   cursor: pointer;
// }
// .btns {
//   position: absolute;
//   z-index: 9;
//   left: 10px;
//   bottom: 200px;
//   color: blue;
//   font-size: 20px;
//   cursor: pointer;
// }

/deep/ .map-pic {
  object-fit: contain;
}
/deep/ .leaflet-interactive {
  fill: #fff;
  stroke: #EE443F;
  // fill-opacity: 1;
}
</style>